import React from 'react';
import type { Slot } from '../../types/slot';
import { useSiteSettings } from '../../contexts/SiteSettingsContext';
import { SlotRow, rowGrid } from './SlotRow';
export function SlotTable({
  slots,
  onDemo
}: {
  slots: Slot[];
  onDemo: (s: Slot) => void;
}) {
  const {
    showRealMoneyCtas
  } = useSiteSettings();
  return <div className="overflow-hidden rounded-2xl border border-line bg-surface" data-id="element-254" data-mp="y218faj5pism">
      <div className={`hidden gap-x-4 border-b border-line bg-paper/60 px-6 py-3 text-xs font-medium text-muted md:grid ${rowGrid}`} aria-hidden="true" data-id="element-255" data-mp="1dmmmjj2wyxc">
        <span data-id="element-256" data-mp="adi0wx7xla1l">#</span>
        <span data-id="element-257" data-mp="ad9p78njoarz">Slot</span>
        <span data-id="element-258" data-mp="acq9zzpa40hn">RTP</span>
        <span data-id="element-259" data-mp="abf33r0jecmb">Volatiliteit</span>
        <span data-id="element-260" data-mp="f3yjevqlzlut">Max. winst</span>
        <span data-id="element-261" data-mp="f59t1c6qjntu">Score</span>
        <span className="text-right" data-id="element-262" data-mp="f5jcegx9ywqk">{showRealMoneyCtas ? 'Spelen' : 'Bekijken'}</span>
      </div>
      <ol data-id="element-263" data-mp="3dtynk7cz4e6k">
        {slots.map(s => <SlotRow key={s.slug} slot={s} onDemo={onDemo} data-id="element-264" data-mp="3it1pvk1kk6au" />)}
      </ol>
    </div>;
}